import type { FocusEventHandler } from "react";
import { cn } from "@/lib/cn";

interface LocationAttributionProps {
  className?: string;
  onBlur?: FocusEventHandler<HTMLAnchorElement>;
}

export function LocationAttribution({ className, onBlur }: LocationAttributionProps) {
  return (
    <a
      href="https://www.openstreetmap.org/copyright"
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "block px-3.5 py-2 text-[12px] text-slate underline underline-offset-2 focus-visible:outline-2 focus-visible:outline-electric",
        className,
      )}
      onBlur={onBlur}
    >
      © OpenStreetMap contributors
    </a>
  );
}
